import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonConstant} from '../../app.constants';

@Component({
  selector: 'achoo-pagination',
  templateUrl: './achoo-pagination.component.html',
  styleUrls: ['./achoo-pagination.component.scss']
})
export class AchooPaginationComponent {

  @Input() minPage: number;
  @Input() maxPage: number;

  @Output() pageChange: EventEmitter<any> = new EventEmitter<any>();

  public currentPage = 1;

  onPageChange() {
    this.pageChange.emit(this.currentPage);
  }

  onPreviousPage() {
    if (this.currentPage > this.minPage) {
      this.currentPage--;
      this.onPageChange();
    }
  }

  onNextPage() {
    if (this.currentPage < this.maxPage) {
      this.currentPage++;
      this.onPageChange();
    }
  }

  validatePageNumber(evt) {
    const key = window.event ? evt.keyCode : evt.which;
    if (key === 13) {
      const nextPage = Number(evt.target.value);
      if (nextPage >= this.minPage && nextPage <= this.maxPage) {
        this.currentPage = nextPage;
        this.onPageChange();
      }
      return true;
    } else if ( key < 48 || key > 57 ) {
      // not allow non-number character
      return false;
    } else {
      return true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-pagination/achoo-pagination.component.ts